module.exports = __webpack_public_path__ + "static/media/CalendarIcon.737e0f15.svg";